import { Row, Col } from 'reactstrap';

const OurIdentity = () => {
    return (
        <Row className='my-5'>
            <Col xs='12' sm='12' md='6' lg='6'>
                <div>
                    <h4>Who are We?</h4>
                    <p>Home Services is a leading multiple service provider company catering to your 360 needs with quality guaranteed. The aim and priority of Home Services are to add value to our consumers’ lives by providing smart solutions to all their problems. Our pride is providing the most extensive range of services. From home maintenance to personal assistance. We make sure that your safety is never compromised. This is why we hire all the staff under the roof of Home Services, just for your satisfaction. Our goal is to become the largest and most famous online home services platform and provide our customers with the best of services and experience. Our experts will give you the most satisfying experience and professionalism. On your demand, all of our best home maintenance and renovation services are available at the very right time and place</p>
                </div>
            </Col>
            <Col xs='12' sm='12' md='6' lg='6'>
                <img src="/Assets/home-image1.jpg" height='100%' width='100%' className='img-thumbnail rounded img-fluid' alt="" />
            </Col>
        </Row>
    )
};

export default OurIdentity;